<template>
  <div class="chargedetails">
    <div class="header">
      <div class="title">智能充电硬件详情</div>
      <div class="border"></div>
    </div>

    <div class="body">
      <div class="left">
        <img :src="chargedetailsLogo" alt="" />
      </div>
      <div class="right">
        <div class="title">基本功能</div>
        <div class="text">
          充电桩（栓）能实现计时、计电度、计金额充电，可以作为市民购电终端。同时为提高公共充电桩（栓）的效率和实用性，今后将陆续增加一桩（栓）多充和为电动自行车充电的功能。
        </div>
        <div class="item-title">优势</div>
        <div class="list">
          <div class="item" v-for="item in list" :key="item.id">
            <img :src="item.logo" alt="" />
            <div>{{ item.title }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import chargedetailsLogo from "../../../../assets/programme/chargedetailsLogo.png";
import yesLogo from "../../../../assets/programme/yesLogo.png";

export default {
  setup() {
    return reactive({
      chargedetailsLogo: chargedetailsLogo,
      list: [
        {
          id: 1,
          title: "自动断电",
          logo: yesLogo,
        },
        {
          id: 2,
          title: "在线充值",
          logo: yesLogo,
        },
        {
          id: 3,
          title: "过载保护",
          logo: yesLogo,
        },
        {
          id: 4,
          title: "联网定位",
          logo: yesLogo,
        },
        {
          id: 5,
          title: "智能数据分析",
          logo: yesLogo,
        },
        {
          id: 6,
          title: "实时监控",
          logo: yesLogo,
        },
        {
          id: 7,
          title: "语音提示",
          logo: yesLogo,
        },
        {
          id: 8,
          title: "多种计费",
          logo: yesLogo,
        },
      ],
    });
  },
};
</script>

<style scoped>
.chargedetails {
  width: 92vw;
  margin: 24px auto 0;
}
.header .title {
  font-size: 16px;
  text-align: center;
}
.header .border {
  width: 16px;
  height: 2px;
  background: #248efb;
  margin: 4px auto 0;
}

.body {
  margin-top: 16px;
}
.body .left {
  text-align: center;
}
.body .left img {
  width: 174px;
  margin-bottom: 16px;
}
.body .right .title {
  font-size: 14px;
  color: #333;
  font-weight: 600;
}
.body .right .text {
  margin-top: 12px;
  color: #3d3d3d;
  font-size: 12px;
}
.body .right .item-title {
  font-size: 14px;
  color: #333;
  margin-top: 16px;
  font-weight: 600;
}
.body .right .list {
  display: flex;
  flex-wrap: wrap;
}
.body .right .list .item {
  width: 115px;
  display: flex;
  align-items: center;
  margin-top: 12px;
}
.body .right .list .item img {
  width: 10px;
  margin-right: 8px;
}
.body .right .list .item div {
  font-size: 12px;
  color: #2a3d50;
}
</style>
